module.exports = __webpack_public_path__ + "static/media/grInfra.934ff5f3.svg";